import BuyersTable from './BuyersTable';

export default BuyersTable;
